var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "member-form tongxin-layout"
  }, [_c('h1', {
    staticClass: "title-with-underline"
  }, [_vm._v(" 請輸入掛號對象資料 ")]), _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("姓名")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.name,
      expression: "formData.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入姓名",
      "maxlength": "50",
      "required": ""
    },
    domProps: {
      "value": _vm.formData.name
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "name", $event.target.value);
      }, _vm.handleNameInput]
    }
  }), _vm.errors.name ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.name))]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("身分證字號")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.idno,
      expression: "formData.idno"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "請輸入身分證字號",
      "maxlength": "10",
      "required": ""
    },
    domProps: {
      "value": _vm.formData.idno
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "idno", $event.target.value);
      }
    }
  }), _vm.errors.idno ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.idno))]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("出生年月日")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.birthday,
      expression: "formData.birthday"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "required": ""
    },
    domProps: {
      "value": _vm.formData.birthday
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "birthday", $event.target.value);
      }
    }
  }), _vm.errors.birthday ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.birthday))]) : _vm._e()]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "required"
  }, [_vm._v("手機號碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.mobile,
      expression: "formData.mobile"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "tel",
      "placeholder": "請輸入手機號碼（09xxxxxxxx）",
      "maxlength": "10",
      "inputmode": "numeric",
      "required": ""
    },
    domProps: {
      "value": _vm.formData.mobile
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "mobile", $event.target.value);
      }
    }
  }), _vm.errors.mobile ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errors.mobile))]) : _vm._e()])]), _c('div', {
    staticStyle: {
      "padding-bottom": "96px"
    }
  }), _c('div', {
    staticClass: "fixed-footer-navigation"
  }, [_c('TongxinNavigation', {
    attrs: {
      "canProceed": !_vm.isLoading,
      "backButtonIsVisible": true,
      "nextButtonIsVisible": true,
      "textForNextStep": '下一步'
    },
    on: {
      "back": _vm.handleBack,
      "next": _vm.handleNext
    }
  })], 1), _vm.isLoading ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }